import type { C_ProductInfo, Image, ProductSwatch } from "~/lib/app.types";
import type { SerializeFrom } from "~/lib/types";

import { useLocationState } from "../../../location-state/location-state";

export type ProductDetailsHystoryState = {
  // C_ProductInfo is extended product type
  product: SerializeFrom<C_ProductInfo>;
  swatch: ProductSwatch;
  image?: Image;
  quickNav?: SerializeFrom<C_ProductInfo>[];
  totalProducts?: number;
  direction?: "forward" | "back";
};
export const isProductDetailsHystoryState = (
  state: any,
): state is ProductDetailsHystoryState => {
  return (
    state &&
    typeof state === "object" &&
    "product" in state &&
    typeof state.product === "object" &&
    state.product !== null &&
    "id" in state.product &&
    "image" in state
  );
};
export const useProductDetailsHistoryState = () => {
  const [state, set] = useLocationState<ProductDetailsHystoryState>();
  if (isProductDetailsHystoryState(state)) return [state, set] as const;
  return [undefined, set] as const;
};
